/*
 * Responsive MegaMenu
 */

/*global jQuery*/
/*jshint expr:true*/
(function ($, w, ns, da) {

    "use strict";

    if (w.RESPONSIVE_MEGAMENU) {
        return;
    }

    // General variables and methods.
    var $window = $(w),
        $html = $("html"),
        currentGrid = $.support.currentGrid(),
        eready = "ready" + ns + da,
        echanged = ["domchanged" + ns + da, "shown.r.modal" + da].join(" "),
        emodalShow = "show.r.modal" + da,
        eresize = ["resize" + ns, "orientationchange" + ns].join(" "),
        eclick = "click" + ns,
        efocusin = "focusin" + ns,
        ekeydown = "keydown" + ns,
        emouseover = "mouseover" + ns,
        emouseout = "mouseout" + ns,
        eshow = "show" + ns,
        eshown = "shown" + ns,
        ehide = "hide" + ns,
        ehidden = "hidden" + ns;

    var keys = {
        SPACE: 32,
        ESCAPE: 27
    };

    // The MegaMenu class definition
    var MegaMenu = function (element, options) {

        this.$element = $(element).addClass("megamenu");

        this.defaults = {
            start: "xxs",
            end: "m",
            trigger: null
        };

        this.options = $.extend({}, this.defaults, options);
        this.$button = this.options.trigger ? $(this.options.trigger) : this.$element.children("button").first();
        this.transitioning = false;
        this.lastScroll = 0;
        this.end = $.inArray(this.options.end, currentGrid.range);

        this.hidden = (function () {
            return !$("html").is("[data-open]");
        }());

        // Should we indect a button.
        if (currentGrid.index < this.end || this.end === -1) {
            if (!this.$button.length) {
                this.$button = $("<button/>").text("Menu").prependTo(this.$element);
            }
        } else {
            this.show();
        }

        var id = this.$element.attr("id") || "megamenu-" + $.pseudoUnique();

        this.$element.attr({
            "id": id,
            "role": "navigation"
        });

        this.$button.attr({
            "aria-controls": id,
            "aria-expanded": false
        });

        // Bind events.
        this.$button.on(eclick, this.click.bind(this));
        this.$element.on(emouseover, this.mouseover.bind(this)).on(emouseout, this.mouseout.bind(this));
        $(document).on(efocusin, this.focus.bind(this)).on(emodalShow, function () { this.hide(true); }.bind(this));
        var onResize = $.debounce(this.resize.bind(this), 15);
        $(w).off(eresize).on(eresize, onResize);
    };

    MegaMenu.prototype.toggle = function () {
        this[!this.hidden ? "hide" : "show"]();
    };

    MegaMenu.prototype.show = function () {

        if (this.transitioning) {
            return;
        }

        if (!this.hidden) {
            return;
        }

        this.transitioning = true;

        var showEvent = $.Event(eshow),
            shownEvent = $.Event(eshown);

        this.$element.trigger(showEvent);

        if (showEvent.isDefaultPrevented()) {
            return;
        }

        var complete = function () {
            // ReSharper disable once MisuseOfOwnerFunctionThis
            this.transitioning = false;
            this.hidden = false;
            this.$button.attr({
                "aria-expanded": true
            });

            $(document).on(ekeydown, this.keydown.bind(this));

            this.$element.trigger(shownEvent);

        }.bind(this);

        if (currentGrid.index < this.end || this.end === -1) {
            this.lastScroll = $window.scrollTop();
            //$.toggleBodyLock();
        }

        $html.attr("data-open", "");

        // Do our callback
        this.$element.addClass("open visible").onTransitionEnd(complete).ensureTransitionEnd();
    };

    MegaMenu.prototype.hide = function (noLock) {

        if (this.transitioning) {
            return;
        }

        if (this.hidden) {
            return;
        }

        this.transitioning = true;

        var hideEvent = $.Event(ehide),
            hiddenEvent = $.Event(ehidden);

        this.$element.trigger(hideEvent);

        if (hideEvent.isDefaultPrevented()) {
            return;
        }

        var complete = function () {
            this.$element.removeClass("visible");
            this.$button.attr({
                "aria-expanded": false
            });

            // ReSharper disable once MisuseOfOwnerFunctionThis
            this.transitioning = false;
            this.hidden = true;

            // Unbind the handlers
            $(document).off(ekeydown);

            this.$element.trigger(hiddenEvent);

        }.bind(this);

        if (!noLock) {
            //$.toggleBodyLock();
            $window.scrollTop(this.lastScroll);
        }

        $html.removeAttr("data-open");

        // Do our callback
        this.$element.removeClass("open")
            .onTransitionEnd(complete)
            .ensureTransitionEnd();
    };

    MegaMenu.prototype.click = function () {
        this.toggle();
    };

    MegaMenu.prototype.keydown = function (event) {
        if (event.which === keys.ESCAPE && !this.hidden) {
            this.hide();
        }
    };

    MegaMenu.prototype.focus = function (event) {

        if (!this.hidden) {

            // Ensure that focus is maintained within the menu.
            if (!event.shiftKey && event.target !== this.$element[0] && !$.contains(this.$element[0], event.target)) {
                if (event.target !== this.$button[0]) {
                    this.$button.focus();
                    return false;
                }
            }

            // Force expansion of list items with children.
            var $target = $(event.target),
                $parent = $target.parents("[aria-haspopup]:first");

            // Close all other expanded items.
            this.$element.find("[aria-haspopup]").not($parent).removeAttr("aria-expanded");

            if ($parent.length) {
                $parent.attr("aria-expanded", true);
            }

        }

        return true;
    };

    MegaMenu.prototype.mouseover = function (event) {
        if ($.contains(this.$element[0], event.target)) {
            // Force expansion of list items with children.
            $(event.target).parents("[aria-haspopup]").attr("aria-expanded", true);
        }
    };

    MegaMenu.prototype.mouseout = function () {
        // Clean up.
        this.$element.find("[aria-haspopup]").removeAttr("aria-expanded");
    };

    MegaMenu.prototype.resize = function () {
        // Reassign the current grid.
        currentGrid = $.support.currentGrid();

        // Close the menu so we don't lose the ability to scroll.
        var index = $.inArray(this.options.end, currentGrid.range);
        if (currentGrid.index >= index && index > -1) {
            this.hide();
        }
    };

    // No conflict.
    var old = $.fn.megamenu;

    // Plug-in definition
    $.fn.megamenu = function (options) {
        return this.each(function () {

            var $this = $(this),
                data = $this.data("r.megamenu"),
                opts = typeof options === "object" ? $.extend({}, options) : {};

            if (!data) {
                // Check the data and reassign if not present.
                $this.data("r.megamenu", (data = new MegaMenu(this, opts)));
            }

            // Run the appropriate function is a string is passed.
            if (typeof options === "string" && /(show|hide)/.test(options)) {
                data[options]();
            }
        });
    };

    // Set the public constructor.
    $.fn.megamenu.Constructor = MegaMenu;

    $.fn.megamenu.noConflict = function () {
        $.fn.megamenu = old;
        return this;
    };

    // Data API
    var init = function () {
        $("nav[data-megamenu]").each(function () {
            var $this = $(this),
                loaded = $this.data("r.megamenuLoaded");

            if (!loaded) {
                $this.data("r.megamenuLoaded", true);
                $this.megamenu($.getDataOptions($this, "megamenu"));
            }
        });
    },
    debouncedInit = $.debounce(init, 500);

    $(document).on([eready, echanged].join(" "), function (event) {
        event.type === "ready" ? init() : debouncedInit();
    });

    w.RESPONSIVE_MEGAMENU = true;

}(jQuery, window, ".r.megamenu", ".data-api"));